import FundReportComponent from "features/Report/components/SalaryGroup/FundReport";
import useFundReport from "features/Report/hooks/salaryGroup/useFundReport";

const FundReportPage = () => {
    const fundReportProps = useFundReport();
    return <FundReportComponent {...fundReportProps} />
}

export default FundReportPage;